import styled from 'styled-components';

export const PrivateLayoutStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;
  height: inherit;
`;
